const Images = {
  logo: require('../assets/img/logo-black.png'),
  logoLoginAdsFollo: require('../assets/img/loginAdsFollo.png'),
  logoLoginAdsFolloEn: require('../assets/img/loginAdsFolloen.png'),
  logoFolloWhite: require('../assets/img/follo-logo-white.png'),
};

export default Images;
